export default {
  loginType: "",
};
